import * as _ from 'lodash';
import {
  FETCH_PRODUCT_DETAIL_SUCCEEDED,
  MAP_CATEGORIES_TO_PRODUCT,
  FETCH_PRODUCT_DETAIL_REQUESTED,
  FETCH_PRODUCT_TEMPORARY_PRICE_SUCCEEDED,
  FETCH_PRODUCT_ALLOWED_TRANSITIONS_SUCCEEDED,
  FETCH_PRODUCT_HISTORIES_SUCCEEDED
} from './detail.actions';
import { ROTATE_IMAGE_SUCCEEDED } from '../edit/edit.actions';
import ArrayList from '../../../models/ArrayList';
import Media from '../../../models/Media';

export const detail = (state = { fetched: false, data: {} }, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_DETAIL_SUCCEEDED:
      return _.assign({}, state, { fetched: true, data: action.data });

    case FETCH_PRODUCT_DETAIL_REQUESTED:
      return _.assign({}, state, { fetched: false, data: {} });

    case MAP_CATEGORIES_TO_PRODUCT:
      return _.assign({}, { fetched: true, data: _.assign(state.data, { categories: action.data }) });

    case FETCH_PRODUCT_TEMPORARY_PRICE_SUCCEEDED:
      return _.assign({}, { fetched: true, data: _.assign(state.data, { temporary_price: action.data.data }) });

    case FETCH_PRODUCT_ALLOWED_TRANSITIONS_SUCCEEDED:
      return _.assign({}, { fetched: true, data: _.assign(state.data, { allowed_transition: action.data.data }) });
    case ROTATE_IMAGE_SUCCEEDED:
      return _.assign({}, {
        fetched: true, data: _.assign(state.data, {
          media: new ArrayList(Media, (state.data as any).media.getContent().map(medium => {
            if (medium.id === action.data.id) {
              return action.data;
            } else {
              return medium;
            }
          }))
        })
      });

    case FETCH_PRODUCT_HISTORIES_SUCCEEDED:
      return _.assign({}, {
        fetched: true, data: {
          ...state.data,
          product_histories: {
            ...(state.data['product_histories'] ? state.data['product_histories'] : {}),
            [action.data_type]: action.data
          }
        }
      });

    default:
      return state;
  }
};
